import { Component, OnInit } from '@angular/core';
import { Tutor } from '../../models/tutor.model';
import { TutorService } from '../../services/tutor.service';

@Component({
    selector: 'app-tutor-info',
    templateUrl: './tutor-info.component.html',
    styleUrls: ['./tutor-info.component.scss']
})
export class TutorInfoComponent implements OnInit {

    public headerTitle     : string = 'Mi perfil';
    public headerButtonText: string = 'Editar';
    public headerButtonIcon: string = 'edit';
    public headerButtonUrl : string = '/tutor/edicion';

    public tutor: Tutor;
    public isLoadingData: boolean = true;

    constructor(private tutorService: TutorService) { }

    ngOnInit() {

        this.tutorService.get().subscribe({

            next: (tutor: Tutor) => {
                this.tutor = tutor;
            }

        }).add(() => {
            this.isLoadingData = false;
        });

    }

}
